import axios, { AxiosError, AxiosResponse } from 'axios'
import jsonWebToken from './jsonWebToken'

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      return response
    },
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        window.location.href = '/conta/logout'
        return Promise.reject(error)
      }

      return Promise.reject(error)
    }
  )
}

export { setupAxiosInterceptors }